import { render, staticRenderFns } from "./BatchModal.vue?vue&type=template&id=25e6c847"
import script from "./BatchModal.vue?vue&type=script&lang=js"
export * from "./BatchModal.vue?vue&type=script&lang=js"
import style0 from "./BatchModal.vue?vue&type=style&index=0&id=25e6c847&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports